import type { RouteRecordRaw } from 'vue-router'
import { OldDealsSettingsRouteNames } from '@/routes/user/deals/types'
import { getOldRouteWithRedirect } from '@/utils/oldRouteRedirect'
import { UserSettingsRoutes } from '@/routes/user/settings'

export const getOldDealsSettingsRoute = (): RouteRecordRaw => ({
  name: OldDealsSettingsRouteNames.settingsIndex,
  path: 'deals/settings',
  redirect: { name: OldDealsSettingsRouteNames.settingsOverview },
  children: [
    getOldRouteWithRedirect(OldDealsSettingsRouteNames.settingsOverview, 'overview', UserSettingsRoutes.DealsOverview),
    {
      name: OldDealsSettingsRouteNames.settingsPipelineBase,
      path: ':pipelineId',
      redirect: { name: OldDealsSettingsRouteNames.settingsPipeline },
      children: [
        getOldRouteWithRedirect(OldDealsSettingsRouteNames.settingsPipeline, '', UserSettingsRoutes.DealsPipeline),
        getOldRouteWithRedirect(
          OldDealsSettingsRouteNames.settingsPipelineArchived,
          'archived',
          UserSettingsRoutes.DealsPipelineArchived,
        ),
        getOldRouteWithRedirect(
          OldDealsSettingsRouteNames.settingsPipelineStages,
          'stages',
          UserSettingsRoutes.DealsPipelineStage,
        ),
      ],
    },
  ],
})
